import CodeIcon from '@mui/icons-material/Code';

const TechStyle = {
  id: 'tech',
  name: 'Tech',
  description: 'Modern feel with icons and section borders.',
  icon: <CodeIcon />,
  settings: {
    useSectionIcons: true,
    useContactIcons: true,
    showSectionTitleBorder: true,
    sectionTitleBorderWidth: '2px', // Example width
  },
};

export default TechStyle; 